import { ListPlus } from 'lucide-react'
import { QuoteItem_ } from 'src/api/db/apiQuoteItem'
import { DecorationRow } from './DecorationRow'
import { AddDecorationButton } from './AddDecorationButton'
import { AddCustomSubItemRowButton } from './AddCustomSubItemRowButton'
import { MiscRow } from './MiscRow'
import { QUOTE_SUB_ITEM_TYPE_CUSTOM_LINE } from '../../../../../consts'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const ProductRowExpandedSection = ({
  quote_item,
  isEditMode,
  isAdmin,
  showDiscountColumn,
  onAddDecoration,
  onAddCustomSubRow,
  onDeleteQuoteSubItem,
  isReadOnly = false,
}: {
  quote_item: QuoteItem_
  isEditMode: boolean
  isAdmin: boolean
  showDiscountColumn: boolean
  onAddDecoration: () => void
  onAddCustomSubRow: () => void
  onDeleteQuoteSubItem: (id: number) => void
  isReadOnly?: boolean
}) => {
  const { t } = useLocalization()

  return (
  <>
    {quote_item.quote_sub_item
      ?.filter((quote_sub_item) => quote_sub_item.type === 'decoration')
      .map((quote_sub_item) => (
        <DecorationRow
          key={quote_sub_item.id}
          quote_item={quote_item}
          quote_sub_item={quote_sub_item}
          isEditMode={isEditMode}
          showDiscountColumn={showDiscountColumn}
          isReadOnly={isReadOnly}
        />
      ))}

    {quote_item.quote_sub_item
      ?.filter((quote_sub_item) => quote_sub_item.type === 'setup_cost')
      .map((quote_sub_item) => (
        <MiscRow
          key={quote_sub_item.id}
          id={quote_sub_item.id}
          description={quote_sub_item.description || ''}
          unit_price={quote_sub_item.unit_price || 0}
          quantity={quote_sub_item.quantity || 1}
          notes={quote_sub_item.notes}
          isEditMode={isEditMode}
          showDiscountColumn={showDiscountColumn}
          isReadOnly={isReadOnly}
          typeLabel={t('Setup cost', 'Startkostnad')}
          handleDelete={() => {
            onDeleteQuoteSubItem(quote_sub_item.id)
          }}
        />
      ))}

    {quote_item.quote_sub_item
      ?.filter(
        (quote_sub_item) =>
          quote_sub_item.type === QUOTE_SUB_ITEM_TYPE_CUSTOM_LINE
      )
      .map((quote_sub_item) => (
        <MiscRow
          key={quote_sub_item.id}
          id={quote_sub_item.id}
          icon={ListPlus}
          description={quote_sub_item.description || ''}
          unit_price={quote_sub_item.unit_price || 0}
          quantity={quote_sub_item.quantity || 1}
          notes={quote_sub_item.notes}
          isEditMode={isEditMode}
          showDiscountColumn={showDiscountColumn}
          isReadOnly={isReadOnly}
          typeLabel={t('Extra line', 'Extrarad')}
          handleDelete={() => {
            onDeleteQuoteSubItem(quote_sub_item.id)
          }}
        />
      ))}

    {!isReadOnly && (
      <AddDecorationButton
        onAddDecoration={onAddDecoration}
        showDiscountColumn={showDiscountColumn}
      />
    )}

    {!isReadOnly && isAdmin && (
      <AddCustomSubItemRowButton
        onAddRow={onAddCustomSubRow}
        showDiscountColumn={showDiscountColumn}
      />
    )}
  </>
  )
}
